const state = {
  // 默认未登录
  isLogin:false,
  permission:[],
  // 导航栏菜单数据state
  menuList: [
    {
      name: '首页',
      url: 'index',
      id: '10000',
      icon: '',
      childrenList: [
        {
          name: '用户管理',
          url: 'user',
          id: '11001',
          icon: '',
          childrenList: [
			{
					name: '用户列表',
					url: 'user',
					id: '12001',
					icon: '',
					childrenList: []
				}
			]
        },
        {
          name: '分类管理',
          url: 'cate',
          id: '20001',
          icon: '',
          childrenList: [
				{
					name: '商品分类',
					url: 'cate',
					id: '21001',
					icon: '',
					childrenList: []
				}
			]
        },
		{
			name: '商品管理',
			url: 'goods',
			id: '30001',
			icon: '',
			childrenList: [
				{
					name: '商品管理',
					url: 'goods',
					id: '31001',
					icon: '',
					childrenList: []
				}
			]
		},
		{
			name: '资费管理',
			url: 'money',
			id: '40001',
			icon: '',
			childrenList: [
				{
					name: '资费管理',
					url: 'money',
					id: '41001',
					icon: '',
					childrenList: []
				}
			]
		},
		
      ]
    },
  ],
};
export default state;



// WEBPACK FOOTER //
// ./src/store/state.js